import { render, staticRenderFns } from "./NewDir.vue?vue&type=template&id=6c131138&"
import script from "./NewDir.vue?vue&type=script&lang=js&"
export * from "./NewDir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports